// https://moment.github.io/luxon/#/parsing?id=iso-8601
// https://moment.github.io/luxon/demo/global.html

import { DateTime, Duration } from "luxon";
import Vue from "vue";

const luxonInstance = { DateTime, Duration };

Vue.prototype.$luxon = luxonInstance;

export default luxonInstance;
